/* This file was generated automatically. Do not edit manually. */

export enum AgeCategoryClassification {
    Adult = 'Adult',
    Child = 'Child',
}
